import styled from 'styled-components';

/** The app's multi-line text field. */
const Textarea = styled.textarea`
    width: 100%;
    padding: 0.5rem 0.75rem;
    font: inherit;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.text};
    background-color: ${({ theme, disabled }) => (disabled ? theme.colors.disabled : theme.colors.fillWhite)};
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
    border-radius: var(--radius);
    resize: vertical;
    transition: border-color 0.15s ease;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.main};
    }

    &:disabled {
        cursor: not-allowed;
    }
`;

export default Textarea;
